import { atom } from "jotai"
import { TSite } from "types/api"

// サイト情報　Atom
export const initialSitesAtom: TSite[] = []
export const sitesAtom = atom(initialSitesAtom)